// extracted by mini-css-extract-plugin
export default {"body":"modern_body__Jx7eK","foralign":"modern_foralign__ZnFyp","col1":"modern_col1__d-SOC","font1":"modern_font1__6zy-I"};